import React from "react";
import { RCCAccordion } from "react-common-components";
import IComponentAccordion from "react-common-components/dist/components/Accordion/interface";
import Container from "./styles";

interface IAccordion extends IComponentAccordion{
	unmountOnExit?: boolean;
}

export const CLASSNAME_ACCORDION_HEADER_SHOW_ONLY_ON_HOVER = "rccaccordion-showonly-onhover";

const Accordion: React.FC<IAccordion> = ({
	children,
	header,
	unmountOnExit = true,
	...rest
}) => (
	<RCCAccordion
		TransitionProps={{ unmountOnExit }}
		header={
			<Container>
				{header}
			</Container>
		}
		styleInline={{
			header: `
				background:var(--accordion-color); 
				border: 1px solid var(--border-color); 
				.${CLASSNAME_ACCORDION_HEADER_SHOW_ONLY_ON_HOVER}{ 
					opacity: 0; 
					transition: 200ms ease; 
					@media only screen and (hover: none){
						opacity: 1;
					}
				} 
				&:hover{ 
					.${CLASSNAME_ACCORDION_HEADER_SHOW_ONLY_ON_HOVER}{ 
						opacity: 1;
					} 
				}
			`,
			detail: `
				flex-direction: column;
			`
		}}
		{...rest}
		className="rccaccordion-groupers"
	>
		{typeof children !== "undefined" && children !== null && 
            <> {children} </>
		}
	</RCCAccordion>
);

export default Accordion;
